import {CouponCode} from "./coupon";

export class CouponCodeMapper {

  public static map(data: any): CouponCode {
    let coupon: CouponCode = new CouponCode();

    coupon.couponCode = data.code;
    coupon.couponType = data.discount_type;
    coupon.couponPrice = data.discount_type && ['percent', 'amount'].includes(data.discount_type) && !data.free_days_before_payment ? data.new_price : (data.new_price && !data.free_days_before_payment  ? data.price - data.new_price : 0);
    coupon.newPlanPrice = data.discount_type && ['percent', 'amount'].includes(data.discount_type) && data.new_price;
    coupon.discount = data.discount_type && ['percent', 'amount'].includes(data.discount_type) && data.price - data.new_price;
    coupon.couponLifetime = data && data.lifetime;
    coupon.couponRecurring = data.payments_count;
    coupon.couponDesc = data.description;
    coupon.couponTitle = data.title;
    coupon.couponDiscount = data.first_amount;
    coupon.couponRecurringPaymentsAmount = data.recurring_amount;
    coupon.freeDaysBeforePayment = +data.free_days_before_payment;
    coupon.freeDaysAfterPayment = +data.free_days_after_payment;

    return coupon;
  }

}
